export enum SubscriptionDurationType {
  MONTHS = 'MONTHS',
  YEARS = 'YEARS',
  DAYS = 'DAYS',
}
